

















import mixins from 'vue-typed-mixins'
import WindowResizeListener from '@/abstract/WindowResizeListener'
import { Modals } from '@/constants/modals'
import Subscription from '@/components/Billing/Subscription/Subscription.vue'
import Close from '@/assets/svg/rounded/close.svg?inline'

interface Data {
  modalName: Modals
}

interface Computed {
  modalHeight: number
}

export default mixins(WindowResizeListener).extend<Data, {}, Computed, {}>({
  components: {
    Subscription,
    Close,
  },
  data() {
    return {
      modalName: Modals.TariffsModal,
    }
  },
  computed: {
    modalHeight() {
      if (this.isDesktop) {
        return 1200
      }
      if (this.isTablet) {
        return 800
      }
      return 360
    },
  },
})
